import React from "react";
import styled from "styled-components";

import Showcase from "./Showcase";
import Services from "./Services";
import Contact from "./Contact";

const LandingContainer = styled.section`
  display: block;
  margin-top: 100px;
`;

const Landing = () => (
  <LandingContainer>
    <Showcase />
    <Services />
    <Contact />
  </LandingContainer>
);

export default Landing;
